// extracted by mini-css-extract-plugin
export default {"outlineBtnWrapper":"outlineBtns_outlineBtnWrapper__tJNjz","outlineBtn":"outlineBtns_outlineBtn__Dbtr3"};